import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Preloader from '../Preloder/Preloader';
import axios from 'axios';

const InstitutionLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [UserId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
const [formData, setFormData] = useState({
    institutionName: '',
    ownerName: '',
    ownerPhoneNumber: '',
    trainerName: '',
    district: '',
    taluka: '',
    institutionType: '',
    password: '',
    referralid: localStorage.getItem('UserId'),
    RetypePassword: '',
  });

  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Toggle password visibility
  const handleShowPasswordChange = () => {
    setShowPassword(!showPassword);
  };

  // Handle login form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/institute/institutionlogin`, {
        UserId,
        password,
      });

      if (response.data.message === 'Login successful') {
        localStorage.setItem('isInstitutionLogin', 'true');
        localStorage.setItem('authToken', response.data.token); // Store token
        navigate('/admin');



        if (response.data.user) {
          const { id, ownerName, role, UserId } = response.data.user;
  
            // console.log(response.data.user)
          // Store login details in localStorage
          // localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('username', ownerName);
          localStorage.setItem('userRole', role);
          localStorage.setItem('UserId', UserId);
        //  console.log( localStorage.setItem('userRole', role))
        
     
        
        
        }

      } else {
        setError(response.data.message);
      }
    } catch (error) {
      console.error('Error during login:', error);

      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('An error occurred during login.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <Preloader />}
      <div className="page-wrapper">
        <Header />
        

        <section className="login-page section-space">
          <div className="container">
            <div className="row gutter-y-40">
              <div className="col-lg-6 wow fadeInUp" data-aos="fade-up-right" data-aos-duration="1000">
                <div className="login-page__image">
                  <img src="assets/images/login/login-1-1.jpg" alt="login" />
                </div>
              </div>

              <div className="col-lg-6 wow fadeInUp" data-aos="fade-up-left" data-aos-duration="1000">
                <div className="login-page__form">
                  <span className="login-page__form__top-title" style={{ backgroundColor: '#ffd767' }}>Log in</span>
                  <h2 className="login-page__form__title">Welcome to our community</h2>

                  {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}

                  <form className="login-page__form__box form-one" onSubmit={handleLogin}>
                    <div className="login-page__form__input-box form-one__control">
                      <input
                        className="form-one__control__input"
                        type="text"
                        placeholder="UserId"
                        value={UserId}
                        onChange={(e) => setUserId(e.target.value)}
                        required
                      />
                    </div>
                    <div className="login-page__form__input-box form-one__control">
                      <input
                        className="form-one__control__input"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="login-page__form__input-box login-page__form__checkbox-forgot">
                      <div className="login-page__form__checkbox">
                        <input
                          type="checkbox"
                          id="save_login"
                          checked={showPassword}
                          onChange={handleShowPasswordChange}
                        />
                        <label htmlFor="save_login">Show Password</label>
                      </div>
                      <Link to="/forgot-password" className="login-page__form__forgot">Forgot your password?</Link>
                    </div>

                    <div className="login-page__form__input-box">
                      <button type="submit" className="cleenhearts-btn" disabled={loading}>
                        <span className="cleenhearts-btn__icon-box">
                          <span className="cleenhearts-btn__icon-box__inner"><span className="icon-duble-arrow"></span></span>
                        </span>
                        <span className="cleenhearts-btn__text">{loading ? 'Logging in...' : 'Log in'}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default InstitutionLogin;
